'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makePut = exports.makePost = exports.makeGet = exports.makeDelete = exports.buildUrl = exports.handleResponseUseItemApiError = exports.handleResponse = undefined;

var _config = require('../../../config');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var backupKey = _uuid2.default.v4();

var handleResponse = exports.handleResponse = function handleResponse(_ref) {
    var err = _ref.err,
        reject = _ref.reject,
        resolve = _ref.resolve,
        _ref$response = _ref.response,
        response = _ref$response === undefined ? {} : _ref$response,
        success404 = _ref.success404,
        transform = _ref.transform;

    // If there is a server level error, reject the promise
    if (err) {
        if (success404 && err.status === 404) {
            return resolve(response.body || {});
        }
        return reject(err);
    }

    var body = response.body || {};
    if (transform) {
        body = transform(body);
    }

    // Go ResponseEnvelope
    if ('error' in body && body.error) {
        return reject(body.payload);
    }

    // If the successa and message properties are set in body (item-api response)
    // but success is falsy, reject the promise
    if ('success' in body && 'message' in body && !body.success) {
        return reject(body.message);
    }

    // If the success property is set in body but is falsy, reject the promise
    // Might be some sort of lambda (Flynn)
    if ('success' in body && !body.success) {
        if ('payload' in body) {
            if ('error' in body.payload) {
                // Check if the error is from the create account endpoint for the verify email screen
                if (body.payload.error === 'User Already Exists') {
                    return resolve(body);
                }
                return reject(body.payload.error);
            }
            return reject(body.payload);
        }
        return reject(body);
    }

    // else
    return resolve(body);
};

var handleResponseUseItemApiError = exports.handleResponseUseItemApiError = function handleResponseUseItemApiError(_ref2) {
    var err = _ref2.err,
        reject = _ref2.reject,
        resolve = _ref2.resolve,
        _ref2$response = _ref2.response,
        response = _ref2$response === undefined ? {} : _ref2$response,
        success404 = _ref2.success404,
        transform = _ref2.transform;

    // If there is a server level error, reject the promise
    if (err) {
        if (success404 && err.status === 404) {
            resolve(response.body || {});
        }
        return reject(err);
    }

    var body = response.body || {};
    if (transform) {
        body = transform(body);
    }

    // If the successa and message properties are set in body (item-api response)
    // but success is falsy, reject the promise
    if ('success' in body && 'error' in body && !body.success) {
        return reject(body.error);
    }

    // If the success property is set in body but is falsy, reject the promise
    // Might be some sort of lambda (Flynn)
    if ('success' in body && !body.success) {
        return reject(body);
    }

    // else
    return resolve(body);
};

var addCacheKey = function addCacheKey(request) {
    var c = _config.cachekey;
    if (!_config.cachekey) {
        c = backupKey;
    }
    request.query({ c: c });
    return request;
};

var hosts = [{ path: '<AUCTION-CALENDAR-API>', url: 'https://api.liveauctioneers.com/catalog/APIPATH/DEPLOYMENT' }, { path: '<CATALOG-PREVIEWS-API>', url: 'https://api.liveauctioneers.com/catalog/APIPATH/DEPLOYMENT' }, { path: '<CLERK-SERVICE>', url: 'https://dante-DEPLOYMENT.liveauctioneers.com/APIPATH' }, { path: '<CURRENCY-API>', url: 'https://api.liveauctioneers.com/currency/DEPLOYMENT' }, { path: '<ESCROW-API>', url: 'https://api.liveauctioneers.com/escrow/APIPATH/DEPLOYMENT' }, { path: '<ITEM-API>', url: 'https://item-api-DEPLOYMENT.liveauctioneers.com/APIPATH' }, { path: '<MAINHOST-API>', url: 'https://mainhost-DEPLOYMENT.liveauctioneers.com/APIPATH' }, { path: '<PUSH-NOTIFICATION-API>', url: 'https://api.liveauctioneers.com/push/APIPATH/DEPLOYMENT' }, { path: '<SAVED-SEARCH-API>', url: 'https://api.liveauctioneers.com/savedsearch/APIPATH/DEPLOYMENT' }, { path: '<SEARCH-API>', url: 'https://api.liveauctioneers.com/search/APIPATH/DEPLOYMENT' }, { path: '<STREAM-MANAGER>', url: 'https://api.liveauctioneers.com/stream/APIPATH/DEPLOYMENT' }, { path: '<USER-API>', url: 'https://api.liveauctioneers.com/user/APIPATH/DEPLOYMENT' }];

var buildUrl = exports.buildUrl = function buildUrl(path, deployment) {
    var apiPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var updatedPath = path;
    hosts.forEach(function (obj) {
        if (path.includes(obj.path)) {
            var url = obj.url.replace('DEPLOYMENT', deployment);
            updatedPath = path.replace(obj.path, url);
            updatedPath = updatedPath.replace('APIPATH', apiPath);
        }
    });
    return updatedPath;
};

var buildRequest = function buildRequest(_ref3) {
    var apiPath = _ref3.apiPath,
        authToken = _ref3.authToken,
        deployment = _ref3.deployment,
        path = _ref3.path,
        queryParams = _ref3.queryParams,
        requestFunc = _ref3.requestFunc,
        _ref3$useCacheKey = _ref3.useCacheKey,
        useCacheKey = _ref3$useCacheKey === undefined ? true : _ref3$useCacheKey;

    var url = buildUrl(path, deployment, apiPath);
    var request = requestFunc(url);
    if (useCacheKey) {
        addCacheKey(request);
    }
    if (queryParams) {
        request.query(queryParams);
    }
    if (authToken) {
        request.set('Authorization', 'Bearer ' + authToken);
    }
    return request;
};

var makeDelete = exports.makeDelete = function makeDelete(_ref4) {
    var apiPath = _ref4.apiPath,
        authToken = _ref4.authToken,
        deployment = _ref4.deployment,
        path = _ref4.path,
        queryParams = _ref4.queryParams,
        _ref4$useCacheKey = _ref4.useCacheKey,
        useCacheKey = _ref4$useCacheKey === undefined ? true : _ref4$useCacheKey;
    return buildRequest({ apiPath: apiPath, authToken: authToken, deployment: deployment, path: path, queryParams: queryParams, requestFunc: _superagent2.default.delete, useCacheKey: useCacheKey });
};

var makeGet = exports.makeGet = function makeGet(_ref5) {
    var apiPath = _ref5.apiPath,
        authToken = _ref5.authToken,
        deployment = _ref5.deployment,
        path = _ref5.path,
        queryParams = _ref5.queryParams,
        _ref5$useCacheKey = _ref5.useCacheKey,
        useCacheKey = _ref5$useCacheKey === undefined ? true : _ref5$useCacheKey;
    return buildRequest({ apiPath: apiPath, authToken: authToken, deployment: deployment, path: path, queryParams: queryParams, requestFunc: _superagent2.default.get, useCacheKey: useCacheKey });
};

var makePost = exports.makePost = function makePost(_ref6) {
    var apiPath = _ref6.apiPath,
        authToken = _ref6.authToken,
        deployment = _ref6.deployment,
        path = _ref6.path,
        queryParams = _ref6.queryParams,
        _ref6$useCacheKey = _ref6.useCacheKey,
        useCacheKey = _ref6$useCacheKey === undefined ? true : _ref6$useCacheKey;
    return buildRequest({ apiPath: apiPath, authToken: authToken, deployment: deployment, path: path, queryParams: queryParams, requestFunc: _superagent2.default.post, useCacheKey: useCacheKey });
};

var makePut = exports.makePut = function makePut(_ref7) {
    var apiPath = _ref7.apiPath,
        authToken = _ref7.authToken,
        deployment = _ref7.deployment,
        path = _ref7.path,
        queryParams = _ref7.queryParams,
        _ref7$useCacheKey = _ref7.useCacheKey,
        useCacheKey = _ref7$useCacheKey === undefined ? true : _ref7$useCacheKey;
    return buildRequest({ apiPath: apiPath, authToken: authToken, deployment: deployment, path: path, queryParams: queryParams, requestFunc: _superagent2.default.put, useCacheKey: useCacheKey });
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/helpers.js
// module id = SY39
// module chunks = 60